import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import MenuList from './MenuList';
import {
  getNewBrandDirectoryDesktopFlag,
  getSearchFlags
} from '../../../../refresh/selectors/featureFlagsSelector';
import { getSearchExpFlags } from '../../../../utils/products';
import {getAmplitudeVariantPayload , getAmplitudeVariantPayloadMap} from '../../../../utils/amplitudeCommon';


const { useState } = React;

const Navigation = props => {
  const { category = true, metaData, newDesignLuxe = false, isNewBrandDirectoryDesktop } = props;
  const [mouseInSideDiv, setMouseInSideDiv] = useState('No');
  let {
    metaData: {
      sis = false,
      subHeaderHeight = 0,
      current: { navigation: subStoreNavigation } = {}
    } = {},
    navigation: navdata = {},
    ABFlagObj
  } = props;

  if (sis) {
    navdata = subStoreNavigation;
  }

  if (_isEmpty(navdata)) {
    return null;
  }
  const ulStyle = sis && !newDesignLuxe ? { paddingTop: subHeaderHeight == 100 ? 10 : 0 } : null;
  const ulClass = `level-first ${sis && 'transition-element'}`;
  return (
    <div className="menu-newlist" role="navigation">
      <ul
        className={ulClass}
        style={ulStyle}
        onMouseEnter={() => setMouseInSideDiv('Yes')}
        onMouseLeave={() => setMouseInSideDiv('No')}
      >
        {navdata.map((data, i) => {
          let { name } = data;
          if (name) {
            return (
              <MenuList
                data={data}
                key={i}
                category={category}
                metaData={metaData}
                newDesignLuxe={newDesignLuxe}
                isBrands={name === 'BRANDS'}
                isNewBrandDirectoryDesktop={isNewBrandDirectoryDesktop}
                isMouseInSideDiv={mouseInSideDiv}
                ABFlagObj={ABFlagObj}
              />
            );
          }
        })}
      </ul>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const navigation = state.navigation;

  const searchFlags = getAmplitudeVariantPayload('searchExpFlags',state, getSearchFlags(state));
  

  let ABFlagObj = (state?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(searchFlags, state) : getSearchExpFlags(searchFlags);
  

  return {
    navigation,
    metaData: state.metaData,
    isNewBrandDirectoryDesktop: getNewBrandDirectoryDesktopFlag(state),
    ABFlagObj: ABFlagObj || {},
    ...ownProps
  };
}

export default connect(mapStateToProps)(Navigation);
